import type { Building } from "building-types/building/buildingTypes";
import type { CrownTrimMolding } from "building-types/molding/trimMoldingTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import type { ActiveProfileSource } from "building-types/settings/profileCatalogSettings";
import type { RWTable, Table } from "common/data/table";
import { makeCrownTrimMolding } from "../generationTools/generateCrownTrimMoldingTools";
import memo from "../utils/memo";

function select({
  levels,
  walls,
  rooms,
  wallMasses,
  roomFloorAssemblies,
  trimEdgeBehaviors,
  settings,
  ceilings,
  ceilingsByLevel,
  doc,
  enabledFeatures,
}: Pick<
  Building,
  | "levels"
  | "walls"
  | "rooms"
  | "wallMasses"
  | "roomFloorAssemblies"
  | "trimEdgeBehaviors"
  | "settings"
  | "ceilings"
  | "ceilingsByLevel"
  | "doc"
  | "enabledFeatures"
>) {
  return {
    levels,
    walls,
    rooms,
    wallMasses,
    roomFloorAssemblies,
    trimEdgeBehaviors,
    settings,
    ceilings,
    ceilingsByLevel,
    profiles: doc.profiles,
    settingsToCatalogs: enabledFeatures.settingsToCatalogs,
  };
}

function generate({
  levels,
  walls,
  rooms,
  wallMasses,
  roomFloorAssemblies,
  trimEdgeBehaviors,
  settings,
  ceilings,
  ceilingsByLevel,
  profiles,
  settingsToCatalogs,
}: ReturnType<typeof select>): {
  crownTrimMoldings: Table<CrownTrimMolding>;
  issues: BuildingGenerationIssue[];
} {
  const crownTrimMoldings: RWTable<CrownTrimMolding> = {};
  const issues: BuildingGenerationIssue[] = [];

  const { interiorTrim, profile } = settings;
  const profileSource: ActiveProfileSource = { settingsToCatalogs, profiles, profileSettings: profile };

  for (const i in levels) {
    makeCrownTrimMolding({
      level: levels[i],
      walls,
      wallMasses,
      rooms,
      roomFloorAssemblies,
      trimEdgeBehaviors,
      profileSource,
      ceilings,
      ceilingsByLevel,
      interiorTrim,
      crownTrimMoldings,
      issues,
    });
  }

  return { crownTrimMoldings, issues };
}

export default memo(select, generate);
